import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { BaseApiService } from '@app/core/api/base-api.service';
import { PayloadDto } from '@stores/payloads';

@Injectable({ providedIn: 'root' })
export class PayloadsService {
  private readonly api = inject(BaseApiService);
  private readonly apiVersion = 'v1';
  private readonly resourcePath = `${this.apiVersion}/tenants`;

  getPayloads(tenantUuid: string): Observable<PayloadDto[]> {
    type ApiBusinessEntity = PayloadDto;

    return this.api
      .get<readonly ApiBusinessEntity[]>(`${this.resourcePath}/${tenantUuid}/payloads`, {
        params: { payloadType: 'PAYLOAD_INPUT' },
      })
      .pipe(map((arr) => (Array.isArray(arr) ? arr : [])));
  }
}
